import { Feedback } from "./types/Feedback.interface";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { FeedbackRequest } from "./types/Feedback.interface";
import _feedbackService from "@/services/feedback";

export const getFeedbacks = createAsyncThunk(
  "feedback/getFeedbacks",
  async () => {
    const feedbacks = await _feedbackService.getFeedbacks();
    return feedbacks;
  },
);

export const createFeedback = createAsyncThunk(
  "feedback/createFeedback",
  async ({
    feedback,
    images,
  }: {
    feedback: FeedbackRequest;
    images?: File[];
  }) => {
    const newFeedback = await _feedbackService.createFeedback(feedback, images);
    return newFeedback;
  },
);

export const updateFeedbacks = createAsyncThunk(
  "feedback/updateFeedbacks",
  async (feedbacks: Feedback[]) => {
    const updatedFeedbacks = await _feedbackService.updateFeedbacks(feedbacks);
    return updatedFeedbacks;
  },
);
